/**
 * API密钥管理器
 * 密钥拆分为3份，Base64编码存储，运行时聚合
 */

// 原密钥: 5704383536604a8bb94c83ebc059aa8c (32位)
// 拆分: 570438353660 | 4a8bb94c83eb | c059aa8c
const KEY_PARTS = [
  'NTcwNDM4MzUzNjYw',      // Part1: "570438353660" 的 Base64
  'NGE4YmI5NGM4M2Vi',      // Part2: "4a8bb94c83eb" 的 Base64
  'YzA1OWFhOGM='           // Part3: "c059aa8c" 的 Base64
]

/**
 * 解码并聚合密钥
 */
function decodeKey() {
  try {
    return KEY_PARTS.map(part => atob(part)).join('')
  } catch (e) {
    console.error('Key decode failed')
    return ''
  }
}

// 缓存解码后的密钥（避免重复计算）
let _cachedKey = null

export function getApiKey() {
  if (!_cachedKey) {
    _cachedKey = decodeKey()
  }
  return _cachedKey
}

// 清理缓存（登出时调用）
export function clearKeyCache() {
  _cachedKey = null
}
